/* eslint-disable import/prefer-default-export */
export const PAGE_CONTEXT = {
  LOGIN: 'login',
  SIGNUP: 'signup',
  FORGOT: 'forgot',
  RESET: 'reset',
};

export const LINKS = {
  LEARN_MORE: 'https://help.fairprice.com.sg/hc/en-us/articles/360041679392',
};
